export enum Timezone {
  'utc' = 'utc',
  'cet' = 'cet',
  'CET' = 'CET',
}
